<template>
  <div class="privilege">
    <div class="privilege-top">
      <el-button @click="newGroupingClick(1)" :disabled="addPrivilege==1" :class="[addPrivilege==1?'active':'']">新增分组 +</el-button>
      <div style="clear:both;"></div>
    </div>
    <div class="privilege-bottom">
      <el-table
        :data="yemiandata"
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        border
        style="width: 100%"
      >
        <el-table-column 
        prop="id" 
        label="编号"
        width="50">
          <template slot-scope="scope">{{ scope.row.id | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column 
        prop="group_name" 
        label="分组"
        width="110">
        </el-table-column>
        <el-table-column 
        prop="remark" 
        label="分组描述"
        :show-overflow-tooltip="true"
        width="200">
          <template slot-scope="scope">{{ scope.row.remark | defaultValFilter }}</template>
        </el-table-column>
        <el-table-column 
        label="用户列表">
          <template slot-scope="scope">
            <span class="user-list" v-if="scope.row.userlist.length == 0">--</span>
            <template v-else>
              <span v-for="(item, index) in scope.row.userlist" :key="index">
                {{ item.nickname }}<span v-if="index !== scope.row.userlist.length - 1">, </span>
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column 
        label="操作" 
        :width="widthPrivilege">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="视图维护" placement="top-start">
              <span class="icon icon-block" @click="viewClick(scope.row)" v-if="viewPrivilege==0"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="权限维护" placement="top-start">
              <span class="icon icon-lock" @click="getGroupAuthorityList(scope.row)" v-if="priviPrivilege==0"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分组成员" placement="top-start">
              <span class="icon icon-grouping" @click="userDefend(scope.row)" v-if="membersPrivilege==0"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="编辑分组" placement="top-start">
              <span class="icon icon-edit" @click="editClick(scope.row,2)" v-if="editPrivilege==0"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
              <span class="icon icon-delete" @click="deleteClick(scope.row)" v-if="deletePrivilege==0"></span>
            </el-tooltip>
            
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :total="totalNum"
      ></el-pagination>
    </div>
    <!-- 新建分组 -->
    <el-dialog title :visible.sync="addGroupingDialog" @close="cacleGroupingClick" customClass="add-grouping-dialog" width="934px" :close-on-click-modal="false">
      <p class="title">{{ groupingDialogTitle }}</p>
      <div class="line"></div>
      <div class="content">
        <div class="details">
          <span class="star">*</span>
          <span class="name">分组名称：</span>
          <el-input v-model="group_name" clearable placeholder="请输入分组名称"></el-input>
        </div>
        <div class="details">
          <span class="star">*</span>
          <span class="name">分组描述：</span>
          <el-input v-model="remark" clearable placeholder="请输入分组描述"></el-input>
        </div>
      </div>
      <div class="btn">
        <el-button @click="editOrnew()">确认</el-button>
      </div>
    </el-dialog>
    <!-- 分组成员 -->
    <el-dialog title :visible.sync="groupMemberDialog" @close="userDefendConfirm" customClass="group-member-dialog" width="934px" :close-on-click-modal="false">
      <p class="title">分组成员</p>
      <div class="line"></div>
      <div class="box">
        <span v-for="(item,index) in userDefendList" :key="index">{{ item.nickname }}</span>
        <div style="clear:both;"></div>
      </div>
      <div class="btn">
        <el-button @click="userDefendConfirm()">确认</el-button>
      </div>
    </el-dialog>
    <!-- 权限维护 -->
    <el-dialog title :visible.sync="privilegeMDialog" @close="groupAuthorityCancel" customClass="privilege-m-dialog" width="934px" :close-on-click-modal="false">
      <p class="title">权限维护</p>
      <div class="line"></div>
      <div class="content">
        <div class="content-top">
          <el-checkbox  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </div>
        <div class="content-center">
          <el-table
            :data="children"
            :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
            border
            style="width: 100%">
            <el-table-column
              prop="view_name"
              label="模块"
              width="130">
              <template slot-scope="scope">
                <span style="margin-right:10px;">{{ scope.row.view_name }}</span>
                <el-checkbox v-model="scope.row._check" @change="((val)=>{groupAuthorityChange(val, scope.row.view_id)})"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="方法"
              width="">
              <template slot-scope="scope">
                <div class="view-page" v-for="(item,index) in scope.row.method" :key="index">
                  <el-checkbox v-model="item._check" @change="((val)=>{groupAuthorityPageChange(val, item.method_id)})"></el-checkbox>
                  <span style="margin-right:10px;">{{ item.method_name }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btn">
          <el-button @click="groupAuthorityConfirm()">确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 视图维护 -->
    <el-dialog title :visible.sync="viewMaintenanceDialog" @close="viewCancelClick" customClass="view-maintenance-dialog" width="934px" :close-on-click-modal="false">
      <p class="title">视图维护</p>
      <div class="line"></div>
      <div class="content">
        <div class="content-center">
          <el-table
            :data="viewList"
            :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
            border
            style="width: 100%">
            <el-table-column
              prop="view_name"
              label="模块"
              width="130">
              <template slot-scope="scope">
                <span style="margin-right:10px;">{{ scope.row.view_name }}</span>
                <!-- <el-checkbox :checked="scope.row._check=='true'" @change="((val)=>{viewModularChange(val, scope.row.view_id)})"></el-checkbox> -->
                <el-checkbox v-model="scope.row._check" @change="((val)=>{viewModularChange(val, scope.row.view_id)})"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="页面"
              width="">
              <template slot-scope="scope">
                <div class="view-page" v-for="(item,index) in scope.row.chlid" :key="index">
                  <el-checkbox v-model="item._check" @change="((val)=>{viewPageChange(val, item.view_id,scope.row.view_name)})"></el-checkbox>
                  <span style="margin-right:10px;">{{ item.view_name }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="btn">
          <el-button @click="viewConfirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const cityOptions = [];
export default {
  data() {
    return {
      addGroupingDialog:false,
      groupMemberDialog:false,
      privilegeMDialog:false,
      viewMaintenanceDialog:false,
      groupingDialogTitle:"新建分组",
      input:"",
      tableData: [],
      tableData2:[],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      page: 1,
      checkAll: false,
      checkedCities: [],
      groupAuthorityList2: cityOptions,
      isIndeterminate: true,
      group_name:"",//新建分组
      remark:"",
      viewId:"",
      viewList:[],
      allViewList:[],
      viewChiled:[],
      number:0,
      editId:"",
      userDefendList:[],
      groupAuthorityList:[],
      children:[],
      defaultChildren:[],
      addPrivilege:1,//新建分组
      editPrivilege:1,//编辑分组
      deletePrivilege:1,//删除分组
      membersPrivilege:1,//分组成员
      priviPrivilege:1,//权限维护
      viewPrivilege:1,//视图维护
      widthPrivilege:210,
    };
  },
  mounted() {
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "系统管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "访问管理"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "新建分组"){
                  this.addPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "编辑分组"){
                  this.editPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "删除分组"){
                  this.deletePrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "分组成员"){
                  this.membersPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "权限维护"){
                  this.priviPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "视图维护"){
                  this.viewPrivilege = 0;
                }
              }
            }
          }
        }
      }
      if(this.editPrivilege == 1){
        this.widthPrivilege = this.widthPrivilege - 40;
      }
      if(this.deletePrivilege == 1){
        this.widthPrivilege = this.widthPrivilege - 40;
      }
      if(this.membersPrivilege == 1){
        this.widthPrivilege = this.widthPrivilege - 40;
      }
      if(this.priviPrivilege == 1){
        this.widthPrivilege = this.widthPrivilege - 40;
      }
      if(this.viewPrivilege == 1){
        this.widthPrivilege = this.widthPrivilege - 40;
      }

      this.getDataList();
      this.getViewList();
    });
  },
  methods: {
    currentChange(data) {
      this.endnum = data;
      this.startnum = data-1;
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    handleCheckAllChange(val) {
      this.checkAll=val
     for(let i in this.children){
       this.children[i]._check=val
       for(let j in this.children[i].method){
         this.children[i].method[j]._check=val
       }
     }
    },
    
    handleGroupChange(val,item){
      // debugger
      // console.log(this.defaultChildren);
      if(val == true){
        for(let n in this.defaultChildren){
          if(this.defaultChildren[n].pre_name == item){
            this.defaultChildren[n]._check = false;
            if(this.defaultChildren[n].method.length > 0){
              for(let j in this.defaultChildren[n].method){
                this.defaultChildren[n].method[j]._check = false;
              }
            }
            this.children.push(this.defaultChildren[n]);
          }
        }
      } else if(val == false) {
        for(let o in this.children){
          if(this.children[o].pre_name == item){
            this.children.splice(o);
          }
        }
        this.$forceUpdate();
      }
      // console.log(this.children);
    },
    getDataList(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getGroupList",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.data;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              // debugger
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    newGroupingClick(num){
      this.number = num;
      this.addGroupingDialog = true;
      this.groupingDialogTitle = "新建分组";
    },
    cacleGroupingClick(){
      this.addGroupingDialog = false;
      this.group_name = "";
      this.remark = "";
      this.number = 0;
      this.editId = "";
    },
    editOrnew(){
      if(this.number == 1){
        this.confirmGroupingClick();
      } else if(this.number == 2){
        this.editConfirmGroupingClick();
      }
    },
    confirmGroupingClick(){
      if(this.group_name == "") {
        this.$message.warning("请输入分组名称");
        return;
      } else if(this.remark == "") {
        this.$message.warning("请输入分组描述");
        return;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        group_name:this.group_name,
        remark:this.remark,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/add_group",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.addGroupingDialog = false;
            this.startnum = 0;
            this.endnum = 1;
            this.totalNum = 0;
            this.getDataList();
            this.group_name = "";
            this.remark = "";
            this.number = 0;
            this.editId = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    editConfirmGroupingClick(){
      if(this.group_name == "") {
        this.$message.warning("请输入分组名称");
        return;
      } else if(this.remark == "") {
        this.$message.warning("请输入分组描述");
        return;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:this.editId,
        group_name:this.group_name,
        remark:this.remark,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/edit_group",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.addGroupingDialog = false;
            this.startnum = 0;
            this.endnum = 1;
            this.totalNum = 0;
            this.getDataList();
            this.group_name = "";
            this.remark = "";
            this.number = 0;
            this.editId = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    deleteClick(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/User/del_group",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.startnum = 0;
                this.endnum = 1;
                this.totalNum = 0;
                this.getDataList();
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    viewCancelClick(){
      this.viewMaintenanceDialog = false;
      this.viewList = [];
      this.viewId = "";
    },
    getViewList(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getViewList",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.allViewList = su.data.data;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    viewClick(row){
      this.viewId = row.id;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:row.id
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getGroupViewList",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.viewList = su.data.data;
            this.viewMaintenanceDialog = true;
            for(let i in this.viewList){
              if(this.viewList[i]._check == "true"){
                this.viewList[i]._check = true;
              } else if(this.viewList[i]._check == "false"){
                this.viewList[i]._check = false;
              }
              for(let j in this.viewList[i].chlid){
                if(this.viewList[i].chlid[j]._check == "true"){
                  this.viewList[i].chlid[j]._check = true;
                } else if(this.viewList[i].chlid[j]._check == "false"){
                  this.viewList[i].chlid[j]._check = false;
                }
              }
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    viewConfirmClick(){
      let arr = "";
      for(let i in this.viewList){
        if(this.viewList[i]._check == true){
          arr += this.viewList[i].view_id + ',';
        }
        for(let j in this.viewList[i].chlid){
          if(this.viewList[i].chlid[j]._check == true){
            arr +=  this.viewList[i].chlid[j].view_id + ',';
          }
        }
      }
      arr = arr.substring(0,arr.length-1);//去掉最后一个逗号
      // console.log(arr);
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:this.viewId,
        view_ids:arr,
      };
      // console.log(typeof params.view_ids);
      // return 
      this.$api({
        method: "post",
        url: "/api.php/User/groupViewEdit",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.viewMaintenanceDialog = false;
            this.startnum = 0;
            this.endnum = 1;
            this.totalNum = 0;
            this.getDataList();
            this.viewList = [];
            this.viewId = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    editClick(row,num){
      this.number = num;
      this.addGroupingDialog = true;
      this.groupingDialogTitle = "编辑分组";
      this.editId = row.id;
      this.group_name = row.group_name;
      this.remark = row.remark;
    },
    userDefend(row){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        group_id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/userDefend",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.groupMemberDialog = true;
            this.userDefendList = su.data.data;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    userDefendConfirm(){
      this.groupMemberDialog = false;
      this.userDefendList = [];
    },
    viewModularChange(item,value){
      // console.log(item);
      // console.log(value);
      for(let i in this.viewList){
        if(this.viewList[i].view_id == value){
          this.viewList[i]._check = item;
          if(item == true){
            for(let j in this.viewList[i].chlid){
              this.viewList[i].chlid[j]._check = true;
            }
          } else if(item == false){
            for(let j in this.viewList[i].chlid){
              this.viewList[i].chlid[j]._check = false;
            }
          }
        }
      }
      // console.log(this.viewList);
    },
    viewPageChange(item,value,name){
      for(let i in this.viewList){
        if(this.viewList[i].view_id == value){
          this.viewList[i]._check = item;
        } else {
          for(let j in this.viewList[i].chlid){
            if(this.viewList[i].chlid[j].view_id == value){
              this.viewList[i].chlid[j]._check = item;
            }
          }
        }
        let flag = true;
        if(this.viewList[i].view_name == name){
          for(let o in this.viewList[i].chlid){
            if(this.viewList[i].chlid[o]._check == false){
              flag = false;
            }
          }
          this.viewList[i]._check = flag;
        }
      }
      // console.log(this.viewList);
    },
    getGroupAuthorityList(row){
      this.groupId = row.id;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:row.id,
      };
      this.$api({
        method: "post",
        url: "/api.php/User/getGroupAuthorityList",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.privilegeMDialog = true;
            this.groupAuthorityList = su.data.data;
            let arr = [];      
            for(let i in this.groupAuthorityList){
              this.groupAuthorityList2.push(this.groupAuthorityList[i].view_name);
              if(this.groupAuthorityList[i]._check =="true"){
                this.groupAuthorityList[i]._check = true;
              } else if(this.groupAuthorityList[i]._check =="false"){
                this.groupAuthorityList[i]._check = false;
              }
              for(let j in this.groupAuthorityList[i].chlid){
                this.groupAuthorityList[i].chlid[j].pre_name = this.groupAuthorityList[i].view_name;
                if(this.groupAuthorityList[i].chlid[j]._check =="true"){
                  this.groupAuthorityList[i].chlid[j]._check = true;
                  this.groupAuthorityList[i]._check = true;
                } else if(this.groupAuthorityList[i].chlid[j]._check =="false"){
                  this.groupAuthorityList[i].chlid[j]._check = false;
                }
                for(let z in this.groupAuthorityList[i].chlid[j].method){
                  let flag = true;
                  if(this.groupAuthorityList[i].chlid[j].method[z]._check =="true"){
                    this.groupAuthorityList[i].chlid[j].method[z]._check = true;
                    this.groupAuthorityList[i]._check = true;
                  } else if(this.groupAuthorityList[i].chlid[j].method[z]._check =="false"){
                    this.groupAuthorityList[i].chlid[j].method[z]._check = false;
                    flag = false;
                  }
                  if(flag == true){
                    this.groupAuthorityList[i].chlid[j]._check = true;
                  } else {
                    this.groupAuthorityList[i].chlid[j]._check = false;
                  }
                }
                this.defaultChildren.push(this.groupAuthorityList[i].chlid[j]);
              } 
              if(this.groupAuthorityList[i]._check == true){
                this.checkedCities.push(this.groupAuthorityList[i].view_name);
              }
            }
            // console.log(this.checkedCities);
            for(let m in this.checkedCities){
              for(let n in this.defaultChildren){
                if(this.checkedCities[m] == this.defaultChildren[n].pre_name){
                  this.children.push(this.defaultChildren[n]);
                }
              }
            }
            let flagg=true
            for(let i in this.children){
              if(this.children[i]._check==false){
                flagg=false
              }
            }
            this.checkAll=flagg
            // console.log(this.children);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    groupAuthorityChange(item,value){
      if(item == true){
        this.checkAll=true
        for(let i in this.children){
          if(this.children[i].view_id == value){
            for(let j in this.children[i].method){
              this.children[i].method[j]._check = true;
            }
          }
        }
      } else if(item == false){
        this.checkAll=false
        for(let i in this.children){
          if(this.children[i].view_id == value){
            for(let j in this.children[i].method){
              this.children[i].method[j]._check = false;
            }
          }
        }
      }
    },
    groupAuthorityPageChange(value,item){
      
      for(let i in this.children){
        let flag = true;
        for(let j in this.children[i].method){
          if(this.children[i].method[j]._check == false){
            flag = false;
          }
        }
        this.children[i]._check = flag;
      }
      let adad=true
      for(let g in this.children){
        if(this.children[g]._check==false){
          adad=false
        }
      }
      this.checkAll=adad
    },
    groupAuthorityCancel(){
      this.groupAuthorityList2.length = 0;
      this.checkedCities.length = 0;
      this.groupAuthorityList.length = 0;
      this.children.length = 0;
      this.groupId = "";
      this.groupAuthorityList2 = [];
      this.checkedCities = [];
      this.groupAuthorityList = [];
      this.children = [];
      this.defaultChildren = [];
      this.checkAll = false;
    },
    groupAuthorityConfirm(){
      let arr = "";
      for(let i in this.children){
        for(let j in this.children[i].method){
          if(this.children[i].method[j]._check == true){
            arr += this.children[i].method[j].method_id + ',';
          }
        }
      }
      arr = arr.substring(0,arr.length-1);
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:this.groupId,
        method_ids:arr,
      };
      // console.log(arr);
      // return 
      this.$api({
        method: "post",
        url: "/api.php/User/groupAuthorityEdit",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.privilegeMDialog = false;
            this.startnum = 0;
            this.endnum = 1;
            this.totalNum = 0;
            this.getDataList();
            this.groupAuthorityList2.length = 0;
            this.checkedCities.length = 0;
            this.groupAuthorityList.length = 0;
            this.children.length = 0;
            this.groupId = "";
            this.groupAuthorityList2 = [];
            this.checkedCities = [];
            this.groupAuthorityList = [];
            this.children = [];
            this.defaultChildren = [];
            this.checkAll = false;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
  }
};
</script>

<style scoped lang="scss">
.privilege {
  .privilege-top {
    .el-button {
      float: left;
      margin-left: 1%;
      background-color: #f15500;
      color: #ffffff;
      border: none;
    }
    .el-button.active {
      background-color: #a5a5a5;
    }
  }
  .privilege-bottom {
    width: 98%;
    margin-left: 1%;
    margin-top: 24px;
    .user-list {
      margin-right: 5px;
    }
    .user-list:last-child span {
      display: none;
    }
    .icon {
      display: inline-block;
      margin-right: 16px;
      cursor: pointer;
    }
    .icon-block {
      width: 27px;
      height: 17px;
      background: url( ../../assets/img/icon_3.png) -5px -7px no-repeat;
    }
    .icon-lock {
      width: 17px;
      height: 20px;
      background: url( ../../assets/img/icon_3.png) -52px -5px no-repeat;
    }
    .icon-grouping {
      width: 22px;
      height: 18px;
      background: url( ../../assets/img/icon_3.png) -89px -7px no-repeat;
    }
    .icon-edit {
      width: 19px;
      height: 18px;
      background: url( ../../assets/img/icon_3.png) -131px -7px no-repeat;
    }
    .icon-delete {
      width: 20px;
      height: 19px;
      background: url( ../../assets/img/icon_3.png) -170px -6px no-repeat;
      margin-right: 0px;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 24px;
    margin-top: 20px;
    margin-right: 18px;
  }
  .add-grouping-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .content {
      .details {
        margin-bottom: 12px;
        .star {
          color: #ec0000;
        }
        .name {
          color: #555555;
        }
        .el-input {
          width: 40%;
        }
      }
    }
    .btn {
      margin-top: 30px;
      .el-button {
        width: 26%;
        height: 48px;
        background-color: #0071bd;
        color: #fffeff;
        border:none;
      }
    }
  }
  .group-member-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .box {
      width: 96%;
      margin-left: 2%;
      min-height: 120px;
      span {
        display: inline-block;
        width: 100px;
        height: 36px;
        border: 1px solid #d2d2d2;
        line-height: 36px;
        text-align: center;
        margin-right: 16px;
        float: left;
        margin-bottom: 12px;
        // padding-left: 10px;
        // padding-right: 10px;
      }
      // span:nth-child(8n) {
      //   margin-right: 0px;
      // }
    }
    .btn {
      margin-top: 30px;
      .el-button {
        width: 26%;
        height: 48px;
        background-color: #0071bd;
        color: #fffeff;
        border:none;
      }
    }
  }
  .privilege-m-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .content {
      width: 96%;
      margin-left: 2%;
      .content-top {
        display: flex;
        .el-checkbox {
          margin-right: 30px;
        }
        .el-checkbox-group {
          display: inline-block;
          .el-checkbox {
            margin-right: 15px;
          }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #10c582 !important;
          border-color: #10c582 !important;
        }
      }
      .content-center {
        margin-top: 20px;
        .view-page {
          display: inline-block;
          .el-checkbox {
            margin-right: 4px;
          }
        }
      }
      .btn {
        margin-top: 30px;
        .el-button {
          width: 26%;
          height: 48px;
          background-color: #0071bd;
          color: #fffeff;
          border:none;
        }
      }
    }
  }
  .view-maintenance-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .content-center {
      margin-top: 20px;
      .view-page {
        display: inline-block;
        .el-checkbox {
          margin-right: 4px;
        }
      }
    }
    .content {
      width: 96%;
      margin-left: 2%;
      .btn {
        margin-top: 30px;
        .el-button {
          width: 26%;
          height: 48px;
          background-color: #0071bd;
          color: #fffeff;
          border:none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.privilege {
  .el-table--enable-row-hover .el-table__body tr:hover>td { 
    .icon-block {
      background: url( ../../assets/img/icon_3_1.png) -5px -7px no-repeat;
    }
    .icon-lock {
      background: url( ../../assets/img/icon_3_1.png) -52px -5px no-repeat;
    }
    .icon-grouping {
      background: url( ../../assets/img/icon_3_1.png) -89px -7px no-repeat;
    }
    .icon-edit {
      background: url( ../../assets/img/icon_3_1.png) -131px -7px no-repeat;
    }
    .icon-delete {
      background: url( ../../assets/img/icon_3_1.png) -170px -6px no-repeat;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/systemManagement/privilege.vue